export const FORM_IDS = {
  CREATE: "create-inventory-form",
  EDIT: "edit-inventory-form",
  DELETE: "delete-inventory-form",
};
